import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h8r8747rcv: FaireBrandEntity = {
  token: "b_h8r8747rcv",
  type: "brand",
  name: "Margarita Jewelry Supplies",
  avatarUrl:
    "https://cdn.faire.com/fastly/bf04504093ef403c0ccbe0390bb22eb71f7d8ef3ce78a81f1574f2f9fa63802a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0c5d9280333aefd52774b84a4cba8886fcf69dc379bad58cb636f67263ce4bd9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bf04504093ef403c0ccbe0390bb22eb71f7d8ef3ce78a81f1574f2f9fa63802a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0c5d9280333aefd52774b84a4cba8886fcf69dc379bad58cb636f67263ce4bd9.jpeg",
  location: "Alexandria, VA, USA",
  minimumOrderDollars: 85,
  rating: 4.8,
  reviewCount: 6,
  isInsider: true,
  description:
    "At Margarita Jewelry Supplies, we began our journey over six years ago with a vision to empower jewelry designers with premium materials and unparalleled support. We pride ourselves on being a key distribution hub for all your jewelry needs. Specializing in 14K Gold Filled and .925 Sterling Silver, our commitment is to provide designers like you with the resources to grow and scale your brand successfully.\n\nWhat makes our offerings unique is not just the superior quality of our components, but our understanding of the challenges designers face. Our logistics, centered in Virginia, USA, ensures that you receive fast and reliable shipping directly from our hands to yours, keeping your creative process seamless.\n\nWe're more than just a supplier; we're your partner in elevating your brand. We invite you to join our network and experience the personalized assistance and priority access to our newest collections, crafted to inspire and support your artistic vision.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.730Z",
    importedBy: "entity-db-cli",
  },
};
